import {Local} from "../domain/Local";

export class LocalService {
  getNos(lista: Local[], newButton: boolean, expandido: boolean = false) {
    return lista.filter(l=> l.excluido != true).map(obj => {
      const filhos = newButton ? [{data: {'new': true, id: obj.id}}] : []
      const retorno =  {
        expanded: expandido,
        label: obj.nome,
        key: obj.id + '',
        data: obj,
        children: filhos}
      if(obj.locais && obj.locais?.length > 0){
        // @ts-ignore
        retorno.children.splice(0,0,...this.getNos(obj.locais, newButton))
      }
      return retorno
    })
  }

}
